<template>
    <div class="product_list">
        <div class="box" v-if="isReload==false && product_data.length!==0">
            <!-- 路径导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item to="/" >首页</el-breadcrumb-item>
                <el-breadcrumb-item v-if="this.$route.query.product_class_name">{{this.$route.query.product_class_name}}</el-breadcrumb-item>
                <el-breadcrumb-item v-else>搜索结果</el-breadcrumb-item>
                <el-breadcrumb-item v-if="this.$route.query.product_class_name && product_class_name">{{product_class_name}}</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 条件筛选 -->
            <el-tabs  class="filter" v-if="Object.keys(top_class).length!==0" @tab-click="secondaryClick_more">
                <el-tab-pane :label="top_class.top_class_name" class="product_list_detail">

                    <el-tabs @tab-click="secondaryClick" class="base_line">
                        
                        <el-tab-pane :label="item.product_class_name" :name="item.product_class_id.toString()" v-for="item in class_data" :key="item.product_class_id"></el-tab-pane>
                    
                    </el-tabs>

                </el-tab-pane>
            </el-tabs>
            <!-- 产品列表 -->
            <ul class="product_series" v-if="product_data.length!==0">
                <router-link tag="li" :to="{path:'/product_detail',query:{product_hash:item.product_hash}}" v-for="(item,index) in product_data" :key="'A'+index">
                    <el-image
                        fit="cover"
                        style="width:292px;min-width:292px;height:292px"
                        :src="item.product_img_url"
                    >
                        <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                            <div class="el_image">
                                <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                            </div>
                        </div>
                        <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                            <div class="el_image">
                                <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;">></el-image>
                            </div>
                        </div>
                    </el-image>
                    <span :title="item.product_class_name">{{item.product_class_name}}</span>
                    <span :title="item.product_name" style="font-size:12px;">{{item.product_name}}</span>
                    <span style="font-size:12px;">库存 {{item.store_qty}}</span>
                    <p>
                        <span>￥{{item.discount_price}}</span>
                        <span>￥{{item.unit_price}}</span>
                    </p>
                </router-link>
            </ul>
            <!-- 分页 -->
            <div class="Pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    v-if="lastPage>1"
                    :page-count='lastPage'
                    :current-page='currentPage'
                    @current-change="current_change"
                    @prev-click="prev_click"
                    @next-click="next_click">
                </el-pagination>
            </div>
        </div>
        <!-- 数据加载 -->
        <div v-if="isReload"  style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <div v-loading="true"></div>
            <div style="color:#409eff;font-size:14px;margin:100px 0 0 -14px;">数据加载中</div>
        </div>
        <!-- 无数据 -->
        <div v-if="isReload==false && product_data.length==0"
            style="width:1200px;height:600px;background:transparent;margin:0 auto;" class="el_image">
            <el-image
                fit="cover"
                style="width:600px;height:600px;"
                :src="src.src_null"
            >
                <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                    <div class="el_image">
                        <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:20px"></span>
                    </div>
                </div>
                <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                    <div class="el_image">
                        <el-image  fit="cover" :src="src.src_err"  style="width:100px;height:100px;"></el-image>
                    </div>
                </div>
            </el-image>
        </div>
    </div>
</template>
<script>
import src_err from '@/assets/img/err.png'
import src_null from '@/assets/img/null.png'

export default {
    name:'product_list',
    data() {
        return {
            src:{
                src_err,
                src_null
            },
            // 是否加载
            isReload:true,
            // 一级分类
            top_class:{},
            // 二级分类
            class_data:[],
            //二级分类名称
            product_class_name:'',
            // 商品数据
            product_data:[],
            // 当前页
            currentPage:1,
            // 总页
            lastPage:'',
            tab:{
                label:'',
                name:'',
            }
        }
    },
    props:{
        search_data:{
            type:String
        }
    },
    watch:{
        search_data:function(n){
            this.getSearchContent(n)
        }
    },
    beforeRouteLeave(to, from, next){
        if(to.path!=='/product_list'){
            this.$emit('clear')
            next()
        }
    },
    methods: {
        // 点击分页中的某一页
        current_change(e){
            this.currentPage=e
            this.secondaryClick(this.tab)
        },
        // 前一页
        prev_click(e){
            this.currentPage=e--
            this.secondaryClick(this.tab)
        },
        // 后一页
        next_click(e){
            this.currentPage=e++
            this.secondaryClick(this.tab)
        },
        // 获取全部数据
        secondaryClick_more(){
            this.product_class_name=''
            this.tab.name=''
            this.tab.label=''
            this.currentPage=1
            this.secondaryClick(this.tab)
        },
        // 获取页面数据的ajax
        secondaryClick(tab) {
            if(this.tab.label){
                // 点击二级分类（非首次）
                if(tab.label){
                    if(this.tab.label!==tab.label){
                        this.tab.label=tab.label
                        this.product_class_name=tab.label
                        this.currentPage=1
                    }
                }
            }else{
                // 首次点击二级分类，给this.tab.label赋值
                if(tab.label){
                    this.tab.label=tab.label
                    this.product_class_name=tab.label
                    this.currentPage=1
                }
            }
            // 保存二级分类的ID（首次不会进入）
            let lower=''
            if(tab.name!==''){
                lower=parseInt(tab.name)
                this.tab.name=lower
            }
            this.$http({
                url: 'product_list',
                data: {
                    top:parseInt(this.$route.query.product_top_class_id) ,
                    lower:lower, // tab.name保存着对应的分类id，且只有点击组件才会有tab值
                    page:this.currentPage
                }
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    this.top_class=res.data.top_class
                    this.class_data=res.data.class_data
                    console.log(this.class_data)
                    this.product_data=res.data.product_data

                    this.currentPage=res.data.page.currentPage
                    this.lastPage=res.data.page.lastPage
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 搜索框的ajax
        getSearchContent(o){
            this.top_class={}
            this.class_data=[]
            this.product_data=[]

            this.$http({
                url:'search',
                data:{
                    product_name:o
                }
            }).then((res)=>{
                this.isReload=false
                if(res.code==1){
                    if(res.data.length==0){
                        this.$message({
                            message:`没有找到类似商品`,
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message:`${res.msg}，为您找到${res.data.length}个商品`,
                            type: 'success'
                        });
                    }
                    this.product_data=res.data
                }
                this.$emit('clear')
            }).catch(()=>{

            })
        }
    },
    created(){
        if(this.$route.query.product_name){
            this.getSearchContent(this.$route.query.product_name)
        }else if(this.$route.query.product_top_class_id){
            this.secondaryClick(this.tab)
        }
    },
}
</script>
<style lang="scss" scoped>
.product_list{
    background:#F7F7F5;
    position:relative;
    box-sizing:border-box;
    padding-top:46px;
    min-height: 100%;
}
.box{
    width:1200px;
    height:100%;
    margin:0 auto;
    padding:20px 0;
    box-sizing: border-box;
}
.filter{
    margin-top:30px;
    padding:0px 20px 0 20px;
    background:white;
}
/* 产品列表 */
.product_series{
    display:flex;
    flex-wrap: wrap;
    padding:30px 0;
}
.product_series>li{
    width:292px;
    height:400px;
    // border:1px solid #C3C3C3;
    background:white;
    margin:0 10px 30px 0;
    cursor:pointer;
}
.product_series>li:hover{
    box-shadow:0 10px 30px #DDDD;
    transform: scale(1.05);
    transition:all .3s;
}
.product_series>li:nth-child(4n){
    margin:0 0 30px 0;
}
.product_series>li>p,.product_series>li>span{
    text-align: center;
    display:block;
}
.product_series>li>span{
    height:23px;
    line-height:23px;
    text-overflow:ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.product_series>li>p>span:first-child{
    color:#E51C23;
    font-size:20px;
    margin:0 10px;
}
.product_series>li>p>span:last-child{
    text-decoration: line-through;
    color:#BABCBE;
    font-size:14px;
    margin:0 10px;
}
// 分页
.Pagination{
    display:flex;
    justify-content: flex-end;
    padding:0px 0 60px;
}
</style>
<style scoped>
.product_list >>> .el-tabs__item{
    height:50px!important;
    line-height:50px!important;
}
.product_list >>> .el-tabs__header{
    margin:0!important;
}
.product_list >>> .el-tabs__nav-wrap::after{
    height:1px;
}
.base_line >>> .el-tabs__nav-wrap::after{
    height: 0px;
}
.base_line >>> .el-tabs__active-bar{
    display:none;
}


</style>
<style>
.product_list_detail .el-tabs__nav{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.product_list_detail .el-tabs__item{
    padding-left: 0px;
    padding-right: 40px;
    /* width: 20%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap; */
}
</style>
